module.exports = __webpack_public_path__ + "images/花筑村全景_01.jpg?v=16434ad4";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu5/花筑村全景_01.jpg
 ** module id = 86
 ** module chunks = 1 2
 **/